export const msgKO = {
    channel: '채널',
    ment: '안내멘트',

    alert: '알림',
    confirm: '확인',
    warn: '주의',
    btn_no: '취소',
    btn_yes: '확인',

    magazine: '매거진',
    login: '로그인',
    logout: '로그아웃',
    download: '파일다운로드',
    network: '네트워크',

    network_offline: '현재 오프라인 상태입니다.<br/>인터넷 연결을 확인하세요.',

    confirm_logout: '로그아웃하시겠습니까?',
    confirm_download: '파일을 다운로드하시겠습니까?',

    confirm_play_ment: '안내멘트를 재생하시겠습니까?',
    fail_play_ment: '안내멘트를 재생에 실패했습니다.',
    empty_ment: '검색된 안내멘트가 없습니다.',
    empty_player_channel: '재생중인 채널이 없습니다.',
    empty_player_media: '재생중인 음원이 없습니다.',

    empty_id: '아이디가 없습니다.',
    empty_groupid: '그룹아이디가 없습니다.',
    empty_serviceid: '서비스아이디가 없습니다.',
    empty_period: '기간이 만료되었습니다.',

    prepare: '준비중입니다.',

    play_stats: {
        cmt: '오늘의 편성 재생중',
        ucmt: '사용자 지정 방송 재생중',
        mcmt: '개점 방송 재생중',
        live: '즉시 재생 방송 재생중',
        cme: '일반 방송 재생중',
        ad: '광고 방송 재생중',
        alert: '알림 재생중',
        effect1: '기능성 효과음 재생중',
        effect2: '오늘의 편성 재생중',
        effect3: '오늘의 편성 재생중',
    },

    id_require: '아이디를 입력하세요.',
    pw_require: '비밀번호를 입력하세요.',
    login_fail: '아이디가 없거나 비밀번호가 올바르지 않습니다.',
    api_fail: '서버와 통신시 오류가 발생했습니다.',
    json_fail: '데이터 처리시 오류가 발생했습니다.',
    database_fail: '데이터베이스 처리시 오류가 발생했습니다.',
};


// WEBPACK FOOTER //
// ./src/vars/msg/ko.js